import PerformerComposePage from './PerformerComposePage';

export default PerformerComposePage;